import { DetailsListLayoutMode } from "@fluentui/react";

export type LayoutMode = "justified" | "fixedColumns";

export const getLayoutMode = (layoutMode: LayoutMode | undefined): DetailsListLayoutMode | undefined => {
    if (layoutMode === "fixedColumns") {
        return DetailsListLayoutMode.fixedColumns;
    }

    return DetailsListLayoutMode.justified;
};
